/**
 * eslint-disable
 *
 * @format
 */

import React from 'react'
import localize from '../../Global/Localize'
import { formatDate } from '../../Helpers/formatters'
import SimpleLookup from './SimpleLookup'
function PerformancePillarLookup({ onSelect, displayValue }) {
  return (
    <SimpleLookup
      title={localize('performancePillarLookup')}
      url="/lookup/PerformancePillar/find-by-filter-in-page"
      params={{ filterText: '', pageSize: 10, pageIndex: 0 }}
      columns={[
        {
          label: localize('name'),
          template: r => <>{r.description}</>,
          sortBy: 'description',
        },
        { label: localize('weight'), template: r => <>{r.weight}</> },
        {
          label: localize('isLocked') + '?',
          template: r => (
            <span className="text-capitalize">
              {localize(r.isLocked.toString())}
            </span>
          ),
          sortBy: 'isLocked',
        },
        { label: localize('modifiedBy'), template: r => <>{r.modifiedBy}</> },
        {
          label: localize('modifiedDate'),
          template: r => <>{formatDate(r.modifiedDate, true)}</>,
        },
        { label: localize('createdBy'), template: r => <>{r.createdBy}</> },
        {
          label: localize('createdDate'),
          template: r => <>{formatDate(r.createdDate, false)}</>,
          sortBy: 'createdDate',
        },
      ]}
      onSelect={onSelect}
      displayValue={displayValue}
    />
  )
}
export default PerformancePillarLookup
